import SimpleControl, {
  SimpleControlKind,
} from 'pages/revisions-module/template-editor/editors/template/toolbar/controls/SimpleControl';
import { IconSuperscript } from '@tabler/icons-react';
import { useRichTextEditorContext } from '@mantine/tiptap';

/**
 * A button that allows the user to make the selected text subscript.
 */
export default function Superscript({ kind }: { kind: SimpleControlKind }) {
  const { editor } = useRichTextEditorContext();

  return (
    <SimpleControl
      kind={kind}
      icon={<IconSuperscript />}
      label="Horný index"
      shortcut="Ctrl + ."
      active={editor?.isActive('superscript')}
      onClick={() => editor?.chain().focus().toggleSuperscript().run()}
    />
  );
}
